import {rpAppLink} from "@pg-mono/rp-routes";

import {ISearchFormValues} from "../types/ISearchFormValues";
import {getSearchUrlWithFilters} from "./get_search_url_with_filters";
import type {IRecentFiltersDisplayLinkConfig} from "./recent_filters_display_utils";
import {IRecentFilter} from "./recent_filters_storage";

export const recentFiltersLinkConfig: IRecentFiltersDisplayLinkConfig = {
    singleRegionFriendlyLink: rpAppLink.offer.listFriendly,
    abroadListFriendlyLink: rpAppLink.offer.listFriendlyAbroad,
    multiRegionLink: rpAppLink.offer.multiList
};

export const buildRecentSearchFormValues = (recentFilter: IRecentFilter): ISearchFormValues => ({
    search: recentFilter.search,
    type: recentFilter.filters.type ?? [],
    rooms: recentFilter.filters.rooms,
    price: recentFilter.filters.price,
    area: recentFilter.filters.area || null,
    instalment: recentFilter.filters.instalment || null,
    floor_choices: [],
    construction_end_date: recentFilter.filters.construction_end_date ?? null,
    distance: null,
    house_type: null,
    house_additional_areas: null,
    house_storeys: null
});

export const buildSearchUrl = (searchFormValues: ISearchFormValues): string =>
    getSearchUrlWithFilters({
        ...recentFiltersLinkConfig,
        latestQuery: {},
        searchFormValues
    }).url;
import {rpAppLink} from "@pg-mono/rp-routes";

import {ISearchFormValues} from "../types/ISearchFormValues";
import {getSearchUrlWithFilters} from "./get_search_url_with_filters";
import type {IRecentFiltersDisplayLinkConfig} from "./recent_filters_display_utils";
import {IRecentFilter} from "./recent_filters_storage";

export const recentFiltersLinkConfig: IRecentFiltersDisplayLinkConfig = {
    singleRegionFriendlyLink: rpAppLink.offer.listFriendly,
    abroadListFriendlyLink: rpAppLink.offer.listFriendlyAbroad,
    multiRegionLink: rpAppLink.offer.multiList
};

export const buildRecentSearchFormValues = (recentFilter: IRecentFilter): ISearchFormValues => ({
    search: recentFilter.search,
    type: recentFilter.filters.type ?? [],
    rooms: recentFilter.filters.rooms,
    price: recentFilter.filters.price,
    area: recentFilter.filters.area || null,
    instalment: recentFilter.filters.instalment || null,
    floor_choices: [],
    construction_end_date: recentFilter.filters.construction_end_date ?? null,
    distance: null,
    house_type: null,
    house_additional_areas: null,
    house_storeys: null
});

export const buildSearchUrl = (searchFormValues: ISearchFormValues): string =>
    getSearchUrlWithFilters({
        ...recentFiltersLinkConfig,
        latestQuery: {},
        searchFormValues
    }).url;
